import React from "react";
import Home from "./Home/Home";
import Tetris from "./components/Tetris";

// const App = () => (
//   <div className="App">
//     <Tetris />
//   </div>
// );

const App = () => (
  <div>
    <div>
      <Home />
    </div>
    
  </div>
);

export default App;
